// extracted by mini-css-extract-plugin
export var contentWrapper = "index-module--contentWrapper--X+0x3";
export var imgWrapper = "index-module--imgWrapper--78S-w";
export var signature = "index-module--signature--DEO3K";
export var testimonyCardWrapper = "index-module--testimonyCardWrapper--5cZRv";
export var testimonyCardWrapper_mb = "index-module--testimonyCardWrapper_mb--b-r4l";
export var text = "index-module--text--8fLAI";
export var title = "index-module--title--zSUb+";